import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { cancelCellEdit } from '../../actions/grid-screen';
import { updatePhraseBidRemote } from '../../actions/phrases-grid';
import {
    PhraseMoneyCellEditor,
    PhraseMoneyCellEditorProps,
    PhraseMoneyCellEditorTypes
} from '../../components/PhraseMoneyCellEditor/PhraseMoneyCellEditor';
import { selectGridSourceParams } from '../../selectors/gridSourceParams/gridSourceParams';
import { getEditCellData } from '../../service/GridHelpers/GridHelpers';
import { ConstData } from '../../typings/constants';
import { State } from '../../typings/state';

export type StateProps = Pick<
    PhraseMoneyCellEditorProps,
    'isSaving' | 'error' | 'priceLimit' | 'isGridScrolling'
>;

export interface DispatchProps {
    onSave: (value: number) => void;
    onCancel: () => void;
}

export type OwnProps = {
    id: string;
    groupId: string;
    cellName: 'price' | 'priceContext';
    currency: string;
    bid?: number;
    constants: ConstData;
    cls?: string;
};

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { editCellsData, isGridScrolling } = state.grid;
    const { id, cellName, constants, currency } = ownProps;
    const { view } = selectGridSourceParams(state);

    return {
        priceLimit: constants.currencyConstants[currency],
        isGridScrolling,
        ...getEditCellData(editCellsData, id, cellName, view)
    };
};

const mapDispatchToProps = (
    dispatch: Dispatch<Action>,
    ownProps: OwnProps
): DispatchProps => {
    const { cellName, id, groupId } = ownProps;

    return {
        onSave: (value: number) => {
            dispatch(
                updatePhraseBidRemote(
                    {
                        id,
                        groupId,
                        exactPriceSearch:
                            cellName === 'price' ? value : undefined,
                        exactPriceContext:
                            cellName === 'priceContext' ? value : undefined
                    },
                    cellName
                )
            );
        },
        onCancel: () => {
            dispatch(cancelCellEdit(id, cellName));
        }
    };
};

const mergeProps = (
    stateProps: StateProps,
    dispatchProps: DispatchProps,
    ownProps: OwnProps
): PhraseMoneyCellEditorProps => {
    const { currency, bid, cls } = ownProps;

    return {
        ...{ currency, bid, cls },
        ...stateProps,
        ...dispatchProps,
        type: PhraseMoneyCellEditorTypes.simple
    };
};

export const PhraseMoneyCellSimpleEditorContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps,
    PhraseMoneyCellEditorProps
>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(PhraseMoneyCellEditor);
